import { ClearIcon } from "@mui/x-date-pickers-pro";
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material";
import React, { FC, useState } from "react";

type ClearableTextFieldProps = TextFieldProps & {
  onClear: () => void;
};
export const ClearableTextField: FC<ClearableTextFieldProps> = (props) => {
  const { onClear, onChange, ...textFieldProps } = props;
  const [value, setValue] = useState("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setValue(event.target.value);
    onChange?.(event);
  };

  const handleClear = (): void => {
    setValue("");
    onClear();
  };

  return (
    <TextField
      {...textFieldProps}
      value={value}
      onChange={handleChange}
      slotProps={{
        input: {
          ...textFieldProps.slotProps?.input,
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton
                onClick={handleClear}
                edge="end"
                size="small"
                aria-label="clear input"
                color={textFieldProps.color}
              >
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        },
      }}
    />
  );
};
